import React, { useEffect, useState, useContext } from 'react';
import { FormControl, InputLabel, makeStyles, MenuItem, Select } from '@material-ui/core';
import { commonFilter, NoneArrow } from '../constants/StyleConstants';
import { InventoriesContext } from '../contexts/InventoriesContext';
import { Bold } from './UI/TextFormatters';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  ...commonFilter,
  formControl: {
    minWidth: 120,
  },
  overflow: ({ narrow }) => ({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: narrow ? 150 : 200,
  }),
}));

const optionAll = { id: 'All', management: '', name: 'Todas' };

export const isOptionAllAreas = area => {
  if (typeof area === 'string') {
    return area.isBlank() || area === optionAll.id;
  } else {
    return area.id === optionAll.id;
  }
};

const AreaSelect = ({ value, setValue, style, narrow, title = 'Área', readOnly, disableOptionAll, defaultAll }) => {
  const [options, setOptions] = useState(disableOptionAll ? [] : [optionAll]);
  const classes = useStyles({ narrow });
  const { getTheAreas } = useContext(InventoriesContext);

  useEffect(() => {
    getTheAreas().then(res => {
      const options = disableOptionAll ? res : [optionAll, ...res];
      setOptions(options);
    });
  }, []);

  return (
    <div style={style}>
      <FormControl className={classes.formControl}>
        <InputLabel id="select-state-label">{title}</InputLabel>
        <Select
          className={clsx({ [classes.overflow]: !readOnly })}
          IconComponent={readOnly ? NoneArrow : undefined}
          inputProps={{ readOnly: readOnly }}
          margin="dense"
          labelId="select-state-label"
          id="area-select"
          value={defaultAll && value.isBlank() ? optionAll.id : value}
          renderValue={!readOnly ? optionId => options.filter(o => o.id === optionId)[0].name : undefined}
          onChange={e => setValue(e.target.value)}>
          {options &&
            options.map((area, index) => (
              <MenuItem key={index} value={area.id}>
                {area.id !== optionAll.id ? `${area.management} - ` : ''} <Bold style={{ marginLeft: '0.2em' }}>{area.name}</Bold>
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default AreaSelect;
